import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';

const GetFreeQuotes = ({ username = '', isInBlackList = false }) => {

    const quoteUrl = username ? pathfinder('new_user_manage_request', { username }, { query: { source: 'from_empty_search_page' } }) : pathfinder('join');

    const linkProps = isInBlackList ? { 'href': '/', className: 'no-results-redirect-button' } :
        { 'href': quoteUrl, 'rel': 'nofollow', className: 'no-results-redirect-button js-open-popup-join' };

    return (
        <Button {...linkProps}>
            <I18n k={`search_perseus.error_page.empty_search_results.${isInBlackList ? 'blocked' : 'valid'}.quote`}/>
        </Button>);
};

export default GetFreeQuotes;
